export enum UserTypeEnum {
    ALUNO = 'ALUNO',
    ADMINISTRADOR = 'ADMINISTRADOR',
    ADMINISTRADOR_DETRAN = 'ADMINISTRADOR_DETRAN',
    INSTRUTOR = 'INSTRUTOR',
    OPERADOR_N1 = 'OPERADOR_N1',
    SUPERVISOR = 'SUPERVISOR'
}
